import { compose } from 'recompose'
import LicensePlateInput from './LicensePlateInput'

export default compose()(LicensePlateInput)

